import React from "react";
import { useProfileContext } from "@/contexts/ProfileContext";
import { useAuth } from "@/hooks/domains/auth/useAuth";
import ProfileSectionHandler from "@/components/dashboard/content/ProfileSectionHandler";

export default function ExperiencePage() {
  const { user } = useAuth();
  const { profile, isLoading } = useProfileContext();

  if (isLoading) {
    return (
      <div className="space-y-4 sm:space-y-6 relative z-10 bg-white rounded-lg p-5 shadow-sm border border-gray-200">
        <div className="animate-pulse">
          <div className="h-8 bg-gray-200 rounded w-1/4 mb-4"></div>
          <div className="space-y-4">
            {[...Array(3)].map((_, i) => (
              <div key={i} className="border rounded-lg p-4 space-y-2">
                <div className="h-4 bg-gray-200 rounded w-1/3"></div>
                <div className="h-4 bg-gray-200 rounded w-1/4"></div>
                <div className="h-4 bg-gray-200 rounded w-full"></div>
                <div className="h-4 bg-gray-200 rounded w-3/4"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  // Don't render ProfileSectionHandler until we have a valid profile
  if (!profile) {
    return (
      <div className="space-y-4 sm:space-y-6 relative z-10 bg-white rounded-lg p-5 shadow-sm border border-gray-200">
        <div className="animate-pulse">
          <div className="h-8 bg-gray-200 rounded w-1/4 mb-4"></div>
          <div className="space-y-4">
            {[...Array(3)].map((_, i) => (
              <div key={i} className="border rounded-lg p-4 space-y-2">
                <div className="h-4 bg-gray-200 rounded w-1/3"></div>
                <div className="h-4 bg-gray-200 rounded w-1/4"></div>
                <div className="h-4 bg-gray-200 rounded w-full"></div>
                <div className="h-4 bg-gray-200 rounded w-3/4"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-4 sm:space-y-6 relative z-10 bg-white rounded-lg p-5 shadow-sm border border-gray-200">
      <ProfileSectionHandler type="experience" user={user} profile={profile} isLoading={isLoading} />
    </div>
  );
}
